import React from "react";

interface FixrliLogoIconProps {
  className?: string;
  fill?: string;
}

const FixrliLogoIcon = ({ className = "w-6 h-7", fill = "#FFFFFF" }: FixrliLogoIconProps) => (
  <svg
    className={className}
    viewBox="0 0 30 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.05442 10.6182L15.6127 1.73738L21.3898 5.87767C21.3038 6.11737 21.2562 6.37462 21.2562 6.64161C21.2562 7.96097 22.3977 9.03477 23.8003 9.03477C25.2029 9.03477 26.3444 7.96097 26.3444 6.64161C26.3444 5.32225 25.2029 4.24845 23.8003 4.24845C23.2067 4.24845 22.6608 4.44138 22.2268 4.76294L15.5816 0L0 11.9717L28.5508 12.0486V28.982H21.0314V20.4783L11.0383 20.453L11.0507 30.3462H19.5801V33.6358H3.11591V18.739C4.25434 18.5012 5.10894 17.5443 5.10894 16.4033C5.10894 15.0839 3.9674 14.0101 2.56483 14.0101C1.16225 14.0101 0.0207172 15.0839 0.0207172 16.4033C0.0207172 17.4255 0.70543 18.2995 1.66569 18.6415V35H21.0303V30.3462H30V10.6884L4.05338 10.6182H4.05442ZM24.8952 6.64161C24.8952 7.20872 24.4042 7.67059 23.8013 7.67059C23.1984 7.67059 22.7074 7.20872 22.7074 6.64161C22.7074 6.0745 23.1984 5.61263 23.8013 5.61263C24.4042 5.61263 24.8952 6.0745 24.8952 6.64161ZM2.56586 15.3753C3.16874 15.3753 3.65975 15.8372 3.65975 16.4043C3.65975 16.9714 3.16874 17.4333 2.56586 17.4333C1.96298 17.4333 1.47198 16.9714 1.47198 16.4043C1.47198 15.8372 1.96298 15.3753 2.56586 15.3753ZM19.5822 28.982H12.5009L12.4916 21.8201L19.5822 21.8376V28.981V28.982Z"
      fill={fill}
    />
  </svg>
);

export default FixrliLogoIcon;
